import { ManagementLedgerPage } from "@/features/management-ledger";

const ManagementLedger = () => {
  return <ManagementLedgerPage />;
};

export default ManagementLedger;
